class APIHttpError extends Error {
	response: Response;

	constructor(message: string, response: Response) {
		super(message);
		this.name = 'APIHttpError';
		this.response = response;
	}
}

export { APIHttpError };
